export enum CommunicationSessionType {
  inboundCall = 'inboundCall',
  inboundConversation = 'inboundConversation',
  outboundCall = 'outboundCall',
}
